import { render, staticRenderFns } from "./SwiperContent.vue?vue&type=template&id=04b3b682&scoped=true&"
import script from "./SwiperContent.vue?vue&type=script&lang=js&"
export * from "./SwiperContent.vue?vue&type=script&lang=js&"
import style0 from "./SwiperContent.vue?vue&type=style&index=0&id=04b3b682&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b3b682",
  null
  
)

export default component.exports